<template>
  <div class="page-planification">
    <landing-header />
    <main>

      <!-- HERO -->
      <section class="hero-plan">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-plan">Planning & Prise de RDV</span>
            <h1 class="hero-title">
              Organisez vos semaines<br/>
              <span class="gradient-text">en quelques minutes, pas en quelques heures</span>
            </h1>
            <p class="hero-sub">Planning visuel par technicien, gestion par demi-journée, prise de rendez-vous simplifiée depuis le bureau ou directement par vos clients en ligne.</p>
            <div class="hero-ctas">
              <a href="/contact"><button class="btn-primary">Demander une démo</button></a>
              <a href="/calendrier-reservation" class="btn-outline-large">Voir le calendrier client</a>
            </div>
            <div class="hero-stats">
              <div class="stat-pill"><span class="sv">Couleur</span><span class="sl">Par technicien</span></div>
              <div class="stat-pill"><span class="sv">Demi-journée</span><span class="sl">Granularité</span></div>
              <div class="stat-pill"><span class="sv">Lien</span><span class="sl">Réservation client</span></div>
            </div>
          </div>
          <div class="lg:w-1/2 w-full">
            <!-- Planning mockup -->
            <div class="planning-ui">
              <div class="pui-bar">
                <div class="pui-dots"><span class="pd r"></span><span class="pd y"></span><span class="pd g"></span></div>
                <div class="pui-nav">
                  <button class="pui-nav-btn"><i class="fa-solid fa-chevron-left"></i></button>
                  <span class="pui-week">Semaine du 12 mai 2025</span>
                  <button class="pui-nav-btn"><i class="fa-solid fa-chevron-right"></i></button>
                </div>
                <div class="pui-legend">
                  <span class="leg"><span class="leg-dot marchand"></span>Marchand</span>
                  <span class="leg"><span class="leg-dot petit"></span>Petit</span>
                  <span class="leg"><span class="leg-dot bernard"></span>Bernard</span>
                </div>
              </div>
              <div class="pui-body">
                <div class="pui-grid">
                  <div class="pui-col-head empty-head"></div>
                  <div class="pui-col-head">Lun 12</div>
                  <div class="pui-col-head">Mar 13</div>
                  <div class="pui-col-head">Mer 14</div>
                  <div class="pui-col-head">Jeu 15</div>
                  <div class="pui-col-head">Ven 16</div>
                  <!-- Matin -->
                  <div class="pui-row-head">Matin</div>
                  <div class="pui-cell"><div class="ev marchand-ev"><b>Entretien PAC</b><small>M. Dupont</small></div></div>
                  <div class="pui-cell"><div class="ev marchand-ev"><b>Dépannage</b><small>Résid. Pins</small></div></div>
                  <div class="pui-cell"><div class="ev marchand-ev active-ev"><b>Install. clim</b><small>CH-047 ● En cours</small></div></div>
                  <div class="pui-cell empty-slot"><span>+ Ajouter</span></div>
                  <div class="pui-cell"><div class="ev marchand-ev"><b>VMC tertiaire</b><small>Rue de la Paix</small></div></div>
                  <!-- Après-midi -->
                  <div class="pui-row-head">A-midi</div>
                  <div class="pui-cell empty-slot"><span>+ Ajouter</span></div>
                  <div class="pui-cell"><div class="ev petit-ev"><b>Mise en service</b><small>PAC Bron</small></div></div>
                  <div class="pui-cell"><div class="ev petit-ev active-ev"><b>Install. clim</b><small>CH-047 ● En cours</small></div></div>
                  <div class="pui-cell"><div class="ev petit-ev planned-ev"><b>◎ Clim chambre</b><small>CH-047 · Planifiée</small></div></div>
                  <div class="pui-cell empty-slot"><span>+ Ajouter</span></div>
                </div>
                <!-- 2e technicien -->
                <div class="pui-grid pui-grid-2">
                  <div class="pui-row-head tech-name">S. Bernard</div>
                  <div class="pui-cell"><div class="ev bernard-ev"><b>Entretien clim</b><small>Villeurbanne</small></div></div>
                  <div class="pui-cell"><div class="ev bernard-ev"><b>Entretien clim</b><small>Caluire</small></div></div>
                  <div class="pui-cell empty-slot"><span>+ Ajouter</span></div>
                  <div class="pui-cell"><div class="ev bernard-ev"><b>Diag. fuite</b><small>Écully</small></div></div>
                  <div class="pui-cell rdv-cell"><i class="fa-solid fa-calendar-plus"></i><small>RDV client<br>14h30</small></div>
                </div>
              </div>
              <div class="pui-footer">
                <div class="pui-rdv-notif">
                  <i class="fa-solid fa-bell"></i>
                  Nouveau RDV client — Vendredi 16 mai, 14h30 · Mme Renard · Entretien chaudière
                  <button class="pui-notif-btn">Planifier</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TRUST BAR -->
      <section class="trust-bar">
        <div class="max-w-7xl mx-auto px-4">
          <div class="trust-items">
            <div class="trust-item"><i class="fa-solid fa-palette"></i><span>Couleur par technicien</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-sun"></i><span>Gestion par demi-journée</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-link"></i><span>Lien de réservation intégrable</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-mobile-screen-button"></i><span>Planning sur mobile</span></div>
            <div class="trust-sep"></div>
            <div class="trust-item"><i class="fa-solid fa-bell"></i><span>Alertes en temps réel</span></div>
          </div>
        </div>
      </section>

      <!-- FONCTIONNALITÉS PLANNING -->
      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="section-label">Planning interne</div>
          <h2 class="section-title">Un planning lisible,<br/>même avec 10 techniciens</h2>
          <p class="section-sub">Fini les tableaux Excel bricolés et les WhatsApp de planning. Termoflow donne à chaque technicien sa couleur et à chaque créneau sa clarté.</p>
          <div class="feats-grid-3">
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-palette"></i></div>
              <h3>Couleur par technicien</h3>
              <p>Assignez une couleur unique à chaque technicien. En un coup d'œil, vous voyez qui fait quoi, où, et quand — sans lire chaque ligne.</p>
            </div>
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-sun"></i></div>
              <h3>Gestion par demi-journée</h3>
              <p>Matin ou après-midi — la granularité parfaite pour le secteur CVC. Assez précis pour planifier, assez souple pour absorber les aléas terrain.</p>
            </div>
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-triangle-exclamation"></i></div>
              <h3>Détection de conflits</h3>
              <p>Termoflow vous alerte si vous surchargez la demi journée du technicien.</p>
            </div>
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-mobile-screen-button"></i></div>
              <h3>Mise à jour en temps réel</h3>
              <p>Chaque modification de planning est immédiatement visible sur l'application mobile de vos techniciens. Pas besoin d'appeler pour informer.</p>
            </div>
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-bell"></i></div>
              <h3>Rappels automatiques</h3>
              <p>SMS de rappel envoyé automatiquement au technicien la veille et au client le matin de l'intervention. Zéro oubli, zéro absent.</p>
            </div>
            <div class="feat-card">
              <div class="fi orange"><i class="fa-solid fa-calendar-plus"></i></div>
              <h3>Planification depuis un RDV client</h3>
              <p>Quand un client réserve en ligne, Termoflow vous notifie et vous pouvez planifier l'intervention en 1 clic depuis la notification, sans ressaisie.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- SECTION LIEN RÉSERVATION -->
      <section class="py-24 bg-gray-50 border-y border-gray-100">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-col lg:flex-row gap-16 items-center">
            <div class="lg:w-1/2">
              <div class="section-label">Réservation en ligne</div>
              <h2 class="section-title">Intégrez un calendrier de réservation<br/>sur votre site en 2 minutes</h2>
              <p class="section-sub mb-10">Termoflow génère un lien de réservation personnalisé que vous pouvez partager par SMS, email ou intégrer directement à votre site. Vos clients réservent eux-mêmes — vous n'avez rien à saisir.</p>
              <div class="link-features">
                <div class="lf"><div class="lf-icon"><i class="fa-solid fa-link"></i></div><div><h4>Lien de réservation partageable</h4><p>Partagez l'URL par SMS, email ou réseaux sociaux. Vos clients accèdent au calendrier sans créer de compte.</p></div></div>
                <div class="lf"><div class="lf-icon"><i class="fa-solid fa-code"></i></div><div><h4>Widget intégrable sur votre site</h4><p>Copiez-collez un code d'intégration sur votre site WordPress, Wix ou autre. Le calendrier s'affiche aux couleurs de votre entreprise.</p></div></div>
                <div class="lf"><div class="lf-icon"><i class="fa-solid fa-gear"></i></div><div><h4>Personnalisable à 100%</h4><p>Texte d'accueil, couleurs, logo, créneaux disponibles, types d'interventions proposés — tout est configurable depuis vos paramètres.</p></div></div>
              </div>
              <a href="/calendrier-reservation" class="cta-link-orange">
                Découvrir le calendrier de réservation <i class="fa-solid fa-arrow-right"></i>
              </a>
            </div>
            <div class="lg:w-1/2">
              <div class="link-share-card">
                <div class="lsc-head">Votre lien de réservation</div>
                <div class="lsc-body">
                  <div class="lsc-url">
                    <span class="url-text">https://rdv.termoflow.fr/votre-société</span>
                    <button class="url-copy"><i class="fa-solid fa-copy"></i> Copier</button>
                  </div>
                  <div class="lsc-embed">
                    <div class="embed-label">Intégration site web</div>
                    <div class="embed-code">&lt;iframe src="https://rdv.termoflow.fr/..."<br/>&nbsp;&nbsp;width="100%" height="600"&gt;<br/>&lt;/iframe&gt;</div>
                    <button class="embed-copy"><i class="fa-solid fa-code"></i> Copier le code</button>
                  </div>
                  <div class="lsc-qr">
                    <div class="qr-placeholder">
                      <i class="fa-solid fa-qrcode"></i>
                    </div>
                    <div>
                      <div class="qr-label">QR Code</div>
                      <div class="qr-sub">À imprimer sur vos documents, cartes de visite ou factures</div>
                      <button class="qr-dl"><i class="fa-solid fa-download"></i> Télécharger</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="py-24 text-center bg-white">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-6">Simplifiez votre planning dès aujourd'hui</h2>
          <p class="text-xl text-gray-500 mb-10">Moins de téléphone, moins d'Excel, plus de temps pour vos chantiers.</p>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
            <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
            <a href="/calendrier-reservation" class="btn-outline-large">Voir le calendrier client →</a>
          </div>
        </div>
      </section>

      <landing-roi /><landing-avis />
    </main>
    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'
export default {
  name: 'PlanificationPage',
  components: { LandingHeader, LandingFooter, LandingAvis, 'landing-roi': LandingROI }
}
</script>

<style scoped>
.gradient-text { background: linear-gradient(to right,#f97316,#ef4444); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }
.hero-plan { padding:10rem 0 6rem; background:radial-gradient(ellipse at top right,#fff7ed,transparent 50%),radial-gradient(ellipse at bottom left,#fef2f2,transparent 50%); }
.badge-plan { display:inline-block; padding:.5rem 1rem; background:#fff7ed; color:#c2410c; font-weight:800; font-size:.75rem; border-radius:9999px; margin-bottom:1.5rem; text-transform:uppercase; border:1px solid #fed7aa; letter-spacing:.05em; }
.hero-title { font-size:clamp(2rem,4vw,3.5rem); font-weight:900; color:#111827; line-height:1.15; margin-bottom:1.25rem; }
.hero-sub { font-size:1.1rem; color:#6b7280; line-height:1.7; margin-bottom:2rem; }
.hero-ctas { display:flex; flex-wrap:wrap; gap:1rem; margin-bottom:2rem; }
.hero-stats { display:flex; flex-wrap:wrap; gap:.75rem; padding-top:1.75rem; border-top:1px solid #f1f5f9; }
.stat-pill { display:flex; flex-direction:column; padding:.65rem 1.15rem; background:white; border:1px solid #e5e7eb; border-radius:9999px; }
.sv { font-size:1rem; font-weight:900; color:#f97316; }
.sl { font-size:.65rem; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.05em; }
/* Planning UI */
.planning-ui { background:white; border-radius:1.5rem; border:1px solid #e5e7eb; overflow:hidden; box-shadow:0 20px 60px -12px rgba(0,0,0,.1); }
.pui-bar { background:#f8fafc; border-bottom:1px solid #e5e7eb; padding:.85rem 1.25rem; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:.75rem; }
.pui-dots { display:flex; gap:.4rem; }
.pd { width:10px; height:10px; border-radius:50%; }
.pd.r{background:#ef4444;} .pd.y{background:#f59e0b;} .pd.g{background:#22c55e;}
.pui-nav { display:flex; align-items:center; gap:.6rem; }
.pui-nav-btn { width:1.75rem; height:1.75rem; border-radius:.4rem; border:1px solid #e5e7eb; background:white; color:#6b7280; font-size:.7rem; display:flex; align-items:center; justify-content:center; cursor:pointer; }
.pui-week { font-size:.8rem; font-weight:800; color:#1e293b; }
.pui-legend { display:flex; gap:1rem; }
.leg { display:flex; align-items:center; gap:.4rem; font-size:.72rem; font-weight:700; color:#64748b; }
.leg-dot { width:8px; height:8px; border-radius:50%; }
.leg-dot.marchand{background:#3b82f6;} .leg-dot.petit{background:#22c55e;} .leg-dot.bernard{background:#f59e0b;}
.pui-body { padding:1rem; display:flex; flex-direction:column; gap:.6rem; }
.pui-grid { display:grid; grid-template-columns:60px repeat(5,1fr); gap:.4rem; }
.pui-grid-2 { margin-top:.25rem; padding-top:.75rem; border-top:1px solid #f1f5f9; }
.pui-col-head { text-align:center; font-size:.65rem; font-weight:800; color:#94a3b8; text-transform:uppercase; letter-spacing:.05em; padding:.4rem 0; }
.empty-head{}
.pui-row-head { font-size:.68rem; font-weight:800; color:#94a3b8; display:flex; align-items:center; writing-mode:horizontal-tb; }
.tech-name { color:#374151; font-size:.72rem; }
.pui-cell { min-height:60px; }
.ev { border-radius:.5rem; padding:.5rem .65rem; height:100%; display:flex; flex-direction:column; gap:.15rem; font-size:.72rem; }
.ev b { font-weight:800; line-height:1.2; }
.ev small { font-size:.6rem; opacity:.8; }
.marchand-ev { background:rgba(59,130,246,.1); border:1px solid rgba(59,130,246,.2); color:#1d4ed8; }
.petit-ev { background:rgba(34,197,94,.1); border:1px solid rgba(34,197,94,.2); color:#166534; }
.bernard-ev { background:rgba(245,158,11,.1); border:1px solid rgba(245,158,11,.2); color:#92400e; }
.active-ev { border-width:2px!important; }
.planned-ev { opacity:.7; }
.empty-slot { border:1px dashed #e5e7eb; border-radius:.5rem; display:flex; align-items:center; justify-content:center; cursor:pointer; }
.empty-slot span { font-size:.65rem; font-weight:700; color:#d1d5db; }
.rdv-cell { border:1px dashed #f97316; border-radius:.5rem; background:#fff7ed; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:.25rem; }
.rdv-cell i { color:#f97316; font-size:.9rem; }
.rdv-cell small { font-size:.62rem; font-weight:800; color:#c2410c; text-align:center; }
.pui-footer { padding:.85rem 1.25rem; border-top:1px solid #f1f5f9; }
.pui-rdv-notif { background:#fff7ed; border:1px solid #fed7aa; border-radius:.75rem; padding:.75rem 1rem; display:flex; align-items:center; gap:.75rem; font-size:.78rem; font-weight:700; color:#92400e; flex-wrap:wrap; }
.pui-rdv-notif i { color:#f97316; }
.pui-notif-btn { margin-left:auto; background:#f97316; color:white; font-size:.72rem; font-weight:800; padding:.35rem .9rem; border-radius:9999px; border:none; cursor:pointer; white-space:nowrap; }
/* Trust bar */
.trust-bar{background:#1e293b;padding:1.25rem 0;}
.trust-items{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:0;}
.trust-item{display:flex;align-items:center;gap:.6rem;padding:.5rem 2rem;color:#94a3b8;font-size:.8rem;font-weight:700;}
.trust-item i{color:#f97316;}
.trust-sep{width:1px;height:1.25rem;background:#334155;}
/* Sections */
.section-label{display:inline-block;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.08em;color:#f97316;margin-bottom:1rem;}
.section-title{font-size:2.25rem;font-weight:900;color:#111827;line-height:1.2;margin-bottom:1rem;}
.section-sub{font-size:1.05rem;color:#6b7280;line-height:1.7;max-width:38rem;}
.feats-grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem;margin-top:3rem;}
@media(max-width:900px){.feats-grid-3{grid-template-columns:1fr 1fr;}}
@media(max-width:600px){.feats-grid-3{grid-template-columns:1fr;}}
.feat-card{background:white;border:1px solid #f1f5f9;border-radius:1.25rem;padding:2rem;transition:box-shadow .2s,transform .2s;}
.feat-card:hover{box-shadow:0 8px 30px rgba(0,0,0,.07);transform:translateY(-2px);}
.fi{width:2.75rem;height:2.75rem;border-radius:.75rem;display:flex;align-items:center;justify-content:center;font-size:1.1rem;margin-bottom:1.25rem;}
.fi.orange{background:#fff7ed;color:#f97316;}
.feat-card h3{font-size:1rem;font-weight:800;color:#111827;margin-bottom:.75rem;}
.feat-card p{font-size:.9rem;color:#6b7280;line-height:1.65;}
/* Link share */
.link-features{display:flex;flex-direction:column;gap:1.5rem;margin-bottom:2rem;}
.lf{display:flex;gap:1.25rem;}
.lf-icon{width:2.75rem;height:2.75rem;flex-shrink:0;border-radius:.75rem;background:#fff7ed;color:#f97316;display:flex;align-items:center;justify-content:center;font-size:1rem;}
.lf h4{font-size:.95rem;font-weight:800;color:#111827;margin-bottom:.4rem;}
.lf p{font-size:.87rem;color:#6b7280;line-height:1.6;}
.cta-link-orange{display:inline-flex;align-items:center;gap:.5rem;font-size:.9rem;font-weight:800;color:#f97316;text-decoration:none;border-bottom:2px solid #fed7aa;padding-bottom:2px;}
.link-share-card{background:white;border-radius:1.5rem;border:1px solid #e5e7eb;overflow:hidden;}
.lsc-head{background:#f8fafc;border-bottom:1px solid #e5e7eb;padding:1rem 1.5rem;font-size:.75rem;font-weight:800;color:#64748b;text-transform:uppercase;letter-spacing:.05em;}
.lsc-body{padding:1.5rem;display:flex;flex-direction:column;gap:1.5rem;}
.lsc-url{background:#f8fafc;border:1px solid #e5e7eb;border-radius:.75rem;padding:.85rem 1.1rem;display:flex;align-items:center;justify-content:space-between;gap:.75rem;}
.url-text{font-size:.82rem;font-weight:700;color:#374151;font-family:monospace;}
.url-copy{background:#1e293b;color:white;font-size:.72rem;font-weight:800;padding:.4rem .9rem;border-radius:9999px;border:none;cursor:pointer;white-space:nowrap;display:flex;align-items:center;gap:.4rem;}
.embed-label{font-size:.68rem;font-weight:800;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;margin-bottom:.6rem;}
.embed-code{background:#f8fafc;border:1px solid #e5e7eb;border-radius:.65rem;padding:.85rem 1rem;font-size:.75rem;font-family:monospace;color:#374151;margin-bottom:.75rem;line-height:1.5;}
.embed-copy{background:white;border:1px solid #e5e7eb;color:#374151;font-size:.72rem;font-weight:800;padding:.4rem .9rem;border-radius:9999px;cursor:pointer;display:flex;align-items:center;gap:.4rem;}
.lsc-qr{display:flex;align-items:center;gap:1.25rem;}
.qr-placeholder{width:80px;height:80px;background:#f8fafc;border:1px solid #e5e7eb;border-radius:.75rem;display:flex;align-items:center;justify-content:center;font-size:2.5rem;color:#d1d5db;flex-shrink:0;}
.qr-label{font-size:.85rem;font-weight:800;color:#1e293b;margin-bottom:.2rem;}
.qr-sub{font-size:.75rem;color:#64748b;margin-bottom:.5rem;line-height:1.5;}
.qr-dl{background:white;border:1px solid #e5e7eb;color:#374151;font-size:.72rem;font-weight:800;padding:.4rem .9rem;border-radius:9999px;cursor:pointer;display:flex;align-items:center;gap:.4rem;}
/* Buttons */
.btn-primary{background:linear-gradient(to right,#f97316,#ef4444);color:white;padding:1rem 2.5rem;border-radius:9999px;font-weight:800;border:none;cursor:pointer;font-size:.95rem;}
.btn-primary-large{background:#f97316;color:white;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;border:none;font-size:1.05rem;cursor:pointer;}
.btn-outline-large{border:2px solid #e5e7eb;padding:1.2rem 3rem;border-radius:9999px;font-weight:800;color:#1f2937;text-decoration:none;display:inline-block;}
@media(max-width:1024px){.hero-plan{padding-top:8rem;text-align:center;}.planning-ui{margin-top:3rem;}.section-title{font-size:1.75rem;}}
</style>